import { Directive, ElementRef, HostListener, Input, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonService } from '../services/Common-function/common.service';

@Directive({
  selector: '[ipmTransparentNavbar]'
})
export class TransparentNavbarDirective  {
  private el = inject(ElementRef);

  @Input() divId: string = '.ipm-diwali-section';
  constructor(private relRef: ElementRef, private commonService: CommonService) { }

  @HostListener('window:scroll', ['$event'])

  onWindowScroll(e:any) {
    let element: any = document.getElementById(this.divId);
    const pageYOffset:any = window.pageYOffset;
    if (element) {
      if (pageYOffset > element.offsetTop) {
        element.classList.add('ipm-blur-nav-top-section');
        this.commonService.isSetFilterPositionFixed = true;
      } else {
        element.classList.remove('ipm-blur-nav-top-section');
        this.commonService.isSetFilterPositionFixed = false;
      }
    }
  }
}
